import React from "react";
import Navbar from "../components/Navbar";
import BottomNav from "../components/BottomNav";
import "../styles/home.css";

const Contact = () => {
  return (
    <div className="legal-container">
      <Navbar />

      <div className="legal-content">
        <h1>Contact Us</h1>

        <p>If you have any questions or need support, feel free to contact us.</p>

        <h2>Email</h2>
        <p>markandluth@gmail.com</p>

        <h2>Contact number</h2>
        <p>+91-7592995414</p>

        <h2>Customer Support Hours</h2>
        <p>Monday - Friday : 9 AM – 6 PM</p>

        <h2>Address</h2>
        <p>Mark & Luth Customer Support</p>
        <p>Kerala, India</p>
      </div>

      <BottomNav />
    </div>
  );
};

export default Contact;